import { AiBotConfigContainer } from '@/modules/AiBotConfig';

export const AiBotConfig = (): JSX.Element => <AiBotConfigContainer />;

export default AiBotConfig;
